import Toast from './Toast'

interface ToasterType {
  id: string
  message: string
  type: 'success' | 'error' | 'info' | 'warning'
}

interface ToastContainerProps {
  removeToaster: (id: string) => void
  toastData: ToasterType[]
}

// Matches original space-y-2 vertical stack without layout shift on dismiss.
const TOAST_SLOT_HEIGHT_REM = 5.25
const TOAST_GAP_REM = 0.5

export const ToastContainer = ({
  toastData,
  removeToaster,
}: ToastContainerProps) => {
  // Newest toast at the top-right anchor; older toasts stack downward.
  const stackedToasts = [...toastData].reverse()

  return (
    <div className="fixed top-4 right-0 z-[9999999] pointer-events-none w-[18rem] sm:w-[25rem]">
      {stackedToasts.map((toast: ToasterType, index) => (
        <div
          key={toast.id}
          className="absolute right-0 w-full"
          style={{
            top: `${index * (TOAST_SLOT_HEIGHT_REM + TOAST_GAP_REM)}rem`,
          }}
        >
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => removeToaster(toast.id)}
          />
        </div>
      ))}
    </div>
  )
}
